export const criteriaList = [
  { label: "criteria 1", value: 1 },
  { label: "criteria 2", value: 2 },
];
export const OperatorList = [
  { label: "Operator 1", value: 1 },
  { label: "Operator 2", value: 2 },
];
export const GroupByOption = [
  { label: "PO Number", value: 1 },
  { label: "Operator ", value: 2 },
];
export const initialUserDetails = {
  show_name: null,
  po_prefix: null,
  po_startNo: null,
  production_companies: null,
  currency: null,
  exchange_rate: null,
  notes: null,
};

export const NewShow = {
  show_id: null,
  show_name: "",
  po_prefix: "",
  po_range: null,
  po_start_no: null,
  notes: "",
  is_active: 1,
  prod_companies: [],
  other_show_currencies: [],
  show_seasons: [],
};

export const titleLevelFields = [
  { field: "source_language_id", label: "Source Language", objectType: "Language" },
  { field: "production_brand_id", label: "Production Brand", objectType: "ProductionBrand" },
  { field: "content_structure_id", label: "Content Structure", objectType: "ContentStructure" },
  { field: "content_type_id", label: "Content Type", objectType: "ContentType" },
  { field: "creative_production_type_id", label: "Creative Production Type", objectType: "CreativeProductionType" },
  { field: "first_release_platform_id", label: "First Release Platform", objectType: "FirstReleasePlatform" },
  { field: "vendor_destination_id", label: "Vendor Destination", objectType: "VendorDestination" },
];
